import {
  BrowserClient,
  defaultStackParser,
  makeFetchTransport,
  Scope,
  getDefaultIntegrations,
} from '@sentry/browser';

import { config } from '../config.tsx';

export const sentryClient = new BrowserClient({
  dsn: config.SENTRY_DSN,
  release: `woovi-admin@${process.env.npm_package_version}`,
  transport: makeFetchTransport,
  stackParser: defaultStackParser,
  integrations: getDefaultIntegrations({}),
});

export const sentryHub = new Scope();
sentryHub.setClient(sentryClient);
